module.exports = __webpack_public_path__ + "media/images/front/icon_spmenu_doctor-4a355b869e436d1e009e9b0400614bc9.png";